<template>
  <div
    data-a4-page
    class="relative block h-[1754px] w-[1240px] bg-white"
    style="-webkit-print-color-adjust: exact"
  >
    <!-- Header: Motivationsschreiben + cyan underline -->
    <div class="ml-[62px] pt-[46px]">
      <p
        class="text-[56px] font-bold leading-[68px] tracking-[-1.2px] text-[#1d1d1f]"
      >
        Persönliche Vorstellung
      </p>
      <div class="mt-[24px] h-[6px] w-[200px] bg-[#b8fdff]" />
    </div>

    <!-- Motivation sections -->
    <div class="ml-[74px] mt-[50px] flex w-[1090px] flex-col gap-[50px]">
      <!-- Section 1: Was ist meine Motivation? -->
      <div v-if="account.courseReasonText" class="flex flex-col gap-[18px]">
        <p
          class="text-[47px] font-bold leading-[56px] tracking-[-0.9px] text-[#1d1d1f]"
        >
          Was ist meine Motivation?
        </p>
        <p class="text-[22px] leading-[31px] text-[#1d1d1f]">
          {{ account.courseReasonText }}
        </p>
      </div>

      <!-- Section 2: Welche Erfahrung bringe ich mit? -->
      <div
        v-if="account.practicalExperienceText"
        class="flex flex-col gap-[18px]"
      >
        <p
          class="text-[47px] font-bold leading-[56px] tracking-[-0.9px] text-[#1d1d1f]"
        >
          Welche Erfahrung bringe ich mit?
        </p>
        <p class="text-[22px] leading-[31px] text-[#1d1d1f]">
          {{ account.practicalExperienceText }}
        </p>
      </div>

      <!-- Section 3: Was macht mich aus? -->
      <div
        v-if="account.familyAppreciationText"
        class="flex flex-col gap-[18px]"
      >
        <p
          class="text-[47px] font-bold leading-[56px] tracking-[-0.9px] text-[#1d1d1f]"
        >
          Was macht mich aus?
        </p>
        <p class="text-[22px] leading-[31px] text-[#1d1d1f]">
          {{ account.familyAppreciationText }}
        </p>
      </div>
    </div>

    <!-- Page number: current page equals totalDocPages because this is always the last page -->
    <p
      class="absolute bottom-[40px] right-[48px] text-[22px] leading-[31px] text-[#1d1d1f]"
    >
      {{ totalDocPages }} | {{ totalDocPages }} {{ account.firstName }}
      {{ account.lastName }} | Persönliche Vorstellung
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import accountStore from '@/stores/account.store'

withDefaults(
  defineProps<{
    totalDocPages?: number
  }>(),
  { totalDocPages: 3 },
)

const account = computed(() => accountStore.state.account)
</script>
